<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ 'MITTEILUNGEN' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    @for (newsEntry of news(); track newsEntry.id) {
      <sfg-app-mitteilungen-card [news]="newsEntry"
                                 [routerLink]="['/mitarbeitende/mitteilungen/details/',newsEntry.id]"
                                 routerDirection="forward" />
    }
  </div>
</ion-content>
